/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MathFunctionOffIcon16Light = forwardRef('MathFunctionOffIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M1.883 1.477a.5.5 0 1 0-.707.707l12.26 12.26a.5.5 0 1 0 .707-.707l-2.712-2.711 1.642-1.641a.5.5 0 1 0-.708-.708l-1.64 1.642L7.404 7H8.5a.5.5 0 0 0 0-1H6.406L6 5.595A2.643 2.643 0 0 1 8.643 3H9.5a.5.5 0 0 0 0-1h-.857a3.644 3.644 0 0 0-3.524 2.714L1.883 1.477Z" }),
        React.createElement("path", { d: "M2.5 6h.741l1 1H2.5a.5.5 0 0 1 0-1Z" }),
        React.createElement("path", { d: "M5 10.357V7.76l1 1v1.598A3.643 3.643 0 0 1 2.357 14H2a.5.5 0 0 1 0-1h.357A2.643 2.643 0 0 0 5 10.357Z" }),
        React.createElement("path", { d: "m7.896 13.146 1.246-1.245.707.707-1.246 1.245a.5.5 0 1 1-.707-.707Z" })));
});
